import { useState } from "react";
import { useTranslation } from "react-i18next";
import SelectYear from "../input/SelectYear";
import Table from "./Table";
import SEO from "../common/SEO";

const Archive = ({ formatDate }) => {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const { t, i18n } = useTranslation();

  const isEnglish = (i18n.language || "it").startsWith("en");
  const title = isEnglish ? `Concert Archive (${selectedYear})` : `Storico Concerti (${selectedYear})`;
  const desc = isEnglish
    ? `Explore the complete past concert archive of the Nuova Orchestra da Camera Ferruccio Busoni by year.`
    : `Consulta l'archivio storico completo di tutti i concerti ed eventi passati della Nuova Orchestra da Camera Ferruccio Busoni anno per anno.`;

  return (
    <>
      <SEO title={title} description={desc} />
      <section className="section subpage-section">
        <div className="container subpage-container">
          <div className="text-center mb-4">
            <p className="text-muted max-w-700 mx-auto">
              {isEnglish
                ? "Browse past performances, international festivals, and prestigious chamber concerts."
                : "Esplora i concerti passati, le edizioni delle Mattinate Musicali Internazionali e le tournée dell'Orchestra."}
            </p>
          </div>

          <SelectYear
            setSelectedYear={setSelectedYear}
            t={t}
            years={years}
            selectedYear={selectedYear}
          />
          <Table
            selectedYear={selectedYear}
            setYears={setYears}
            t={t}
            formatDate={formatDate}
          />
        </div>
      </section>
    </>
  );
};

export default Archive;
